import { Contract } from "fhir/r5";

export type AgentExtensionSlug =
  | "medical_reports_agent"
  | "guidance_agent"
  | "discussion_case_agent"
  | "secretary_agent";

export interface ActivationResponsible {
  nome: string;
  cpf: string;
  email: string;
}

function getExtensionValue(
  contract: Contract | null | undefined,
  agentSlug: AgentExtensionSlug,
  field: "nome" | "cpf" | "email" | "provider" | "api-key"
): string {
  const url = `https://fluxmed.com.br/fhir/extension/${agentSlug}/${field}`;
  return (
    contract?.extension?.find((e) => e.url?.includes(url))?.valueString || "-"
  );
}

export function getProviderSlugFromContract(
  contract: Contract | null | undefined,
  agentSlug: AgentExtensionSlug
): string | null {
  const value = getExtensionValue(contract, agentSlug, "provider");
  return value !== "-" ? value : null;
}

export function getApiKeyFromContract(
  contract: Contract | null | undefined,
  agentSlug: AgentExtensionSlug
): string | null {
  const value = getExtensionValue(contract, agentSlug, "api-key");
  return value !== "-" ? value : null;
}

export function getActivationResponsible(
  contract: Contract | null | undefined,
  agentSlug: AgentExtensionSlug
): ActivationResponsible {
  return {
    nome: getExtensionValue(contract, agentSlug, "nome"),
    cpf: getExtensionValue(contract, agentSlug, "cpf"),
    email: getExtensionValue(contract, agentSlug, "email"),
  };
}
